import type { InferDecisionMakersInput } from '../../types';

export type DecisionMakersSkipReason = 'not_local' | 'locality_unresolved' | 'unsupported_country';

/** Why decision makers won't be inferred for this input (CHANGE-98274), for `sap_dmi_eligibility`; `null` means they will. */
export function resolveDecisionMakersSkipReason(
	{ scope, location }: Pick<InferDecisionMakersInput, 'scope' | 'location'>,
	supportedCountries: readonly string[],
): DecisionMakersSkipReason | null {
	if (scope !== 'LOCAL') return 'not_local';
	if (!location.city || !location.adminArea) return 'locality_unresolved';
	if (!location.countryCode || !supportedCountries.includes(location.countryCode)) return 'unsupported_country';
	return null;
}
